import { useEffect, useState } from 'react';
import Select from 'react-select';
import { BaseSelector } from '../../../../models/baseSelector';
import { EmployeeNodeModel } from '../../../../models';
import { AuditLogsFiltersValues } from '../../../../pages/audit-logs/components/AuditLogsFilters';
import { EmployeesAPI } from '../../../../services/external/APIs/employees/Employees.api';

interface Props {
  id: string;
  onChange: (next: AuditLogsFiltersValues) => void;
  value: string | null;
  label: string;
  disabled?: boolean;
  values: AuditLogsFiltersValues;
}

export const EmployeeSelector = ({ id, disabled, onChange, value, label, values }: Props) => {
  const [dataList, setDataList] = useState<BaseSelector[]>([]);
  const [isLoadingData, setIsLoadingData] = useState(true);

  useEffect(() => {
    setIsLoadingData(true);

    EmployeesAPI.getEmployees(false).then((response: EmployeeNodeModel[]) => {
      const employees = response.filter((node) => !node.droppable);

      const convertedResponse = [
        {
          label: '-- Todos los empleados --',
          value: 0,
        },
      ].concat(
        employees.map((item) => ({
          label: `${item.text}`,
          value: Number(item.id),
        })),
      );

      setDataList(convertedResponse);
      setIsLoadingData(false);
    });
  }, []);

  return (
    <>
      {label && label.trim() !== '' && <label>{label}:</label>}

      <div className="p-0 m-0">
        <Select
          id={id}
          key={id}
          name={id}
          options={dataList}
          isLoading={isLoadingData}
          className="text-dark p-0 m-0"
          isSearchable={true}
          isDisabled={disabled}
          placeholder={label ? label : 'Todos los empleados'}
          onChange={(e) => {
            const newValue: string | null = e?.value ? e.value.toString() : null;
            onChange({ ...values, employeeId: newValue });
          }}
          value={
            value
              ? dataList.find((a) => a.value === Number(value))
              : dataList.find((a) => a.value === 0)
          }
        />
      </div>
    </>
  );
};
